@use '../../../scss/global/color';
@use '../../../scss/global/spacing';
@use '../../../scss/global/typography';

:host(.fds-radio) {
  /**
  * @prop --text-color: color of the text used in radio item
  */
  --text-color: var(--fds-color-common-black30, #{color.$default-black-30});

  /**
  * @prop --background-color: background color of radio item
  */
  --background-color: var(--fds-color-common-transparent100, #{color.$default-transparent});

  /**
  * @prop --checkmark-color: check icon color
  */
  --checkmark-color: var(--fds-color-common-secondary100, #{color.$default-secondary-100});

  /**
  * @prop --text-color-disabled: color of the text used in radio item when disabled
  */
  --text-color-disabled: var(--fds-color-common-black150, #{color.$default-black-150});

  /**
  * @prop --background-color-disabled: background color of radio item when disabled
  */
  --background-color-disabled: var(--fds-color-common-transparent100, #{color.$default-transparent});

  /**
  * @prop --checkmark-color-disabled: check icon color when disabled
  */
  --checkmark-color-disabled: var(--fds-color-common-black150, #{color.$default-black-150});

  /**
  * @prop --checkmark-background-color-hover: background color of icon for radio item when hovered
  */
  --checkmark-background-color-hover: var(--fds-color-common-black180, #{color.$default-black-180});

  /**
  * @prop --checkmark-border-color-focus: border color of radio item when focused
  */
  --checkmark-border-color-focus: var(--fds-color-common-blue100, color.$default-blue-100);

  /**
  * @prop --border-color-focus: offset color for border in case of radio item is focused
  */
  --border-color-focus: var(--fds-color-common-white100, #{color.$default-white-100});
}

:host(.fds-radio.dark-mode) {
  --text-color: var(--fds-color-common-white100, #{color.$default-white-100});
  --background-color: var(--fds-color-common-transparent100, #{color.$default-transparent});
  --checkmark-color: var(--fds-color-common-secondary160, #{color.$default-secondary-160});
  --text-color-disabled: var(--fds-color-common-black100, #{color.$default-black-100});
  --background-color-disabled: var(--fds-color-common-transparent100, #{color.$default-transparent});
  --checkmark-color-disabled: var(--fds-color-common-black100, #{color.$default-black-100});
  --checkmark-background-color-hover: var(--fds-color-common-secondary80, #{color.$default-secondary-80});
  --checkmark-border-color-focus: var(--fds-color-common-blue100, color.$default-blue-100);
  --border-color-focus: var(--fds-color-common-black20, #{color.$default-black-20});
}

.fds-radio {
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    align-items: center;

    &--hidden {
      display: none;
    }

    label {
      color: var(--text-color);
      @include typography.ui-text-style(700);
    }
  }

  &__items {
    display: flex;
    gap: spacing.$spacer-2;
  }
}

:host(.fds-radio--vertical) {
  .fds-radio__items {
    gap: 0;
    flex-direction: column;
  }
}

:host(.fds-radio--disabled) {
  .fds-radio__header label {
    color: var(--text-color-disabled);
  }
}
